<template>
  <div class="about main-container light-bg">
    <v-layout align-center class="grid grid-one light-bg">
        <h3 class="display-3">Kontakt</h3>
        <p class="sub-headline">Har du några frågor kring våra tjänster eller vad vi kan erbjuda dig, hör gärna av dig.</p>
    </v-layout>
    <v-layout align-center row wrap class="blue-bg" style="text-align: center; min-height:60vh;" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out">
      <v-flex xs12 class="contact">
         <!-- <h3>- - - - - - -</h3>
        <h3>Vi har för tillfällande problem med vår fasta telefoni. Vi nås lättast via info@smartasystem.se.</h3>
        <h3>- - - - - - -</h3> -->
        <h5 class="display-3 mb-0 mt-5" style="padding-bottom: 60px;!important;">info@smartasystem.se</h5>
        <p><a href="mailto:info@smartasystem.se"><v-icon style="color:whitesmoke">mail_outline</v-icon></a></p>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";

    @Component({
        data(){
            return {}
        },
        components: {},
        methods: {}
    })
    export default class Kontakt extends Vue {}
</script>
<style lang="scss">
 .contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
 }
</style>